import TrialExpiryPage from "./TrialExpiryPage"

export default TrialExpiryPage
